import React from 'react';

import classNames from 'classnames';

import { box, CAPTION_HEIGHT, CONTENT_WIDTH, MARGIN_X, ORG_CHART, pt } from '../slideGeometry';

import BlockCaption from './BlockCaption';

/**
 * An organisation chart, drawn at the coordinates the backend laid it out at:
 * a bordered box per position and a 1 px line per reporting-line segment.
 * Every segment is horizontal or vertical. A manager continued on another
 * slide has a dashed border.
 */
const OrgChartBlock = ({ block }) => {
    const left = MARGIN_X;
    const top = block.y + (block.caption ? CAPTION_HEIGHT : 0);

    return (
        <>
            <BlockCaption block={{ ...block, width: CONTENT_WIDTH }} />
            {(block.segments || []).map(([x1, y1, x2, y2], index) => (
                <div
                    key={`s${index}`}
                    className="tw-bg-charcoal-60"
                    style={box(left + Math.min(x1, x2), top + Math.min(y1, y2), Math.max(1, Math.abs(x2 - x1)), Math.max(1, Math.abs(y2 - y1)))}
                />
            ))}
            {(block.nodes || []).map((node, index) => (
                <div
                    key={`n${index}`}
                    className={classNames(
                        'tw-flex tw-items-center tw-justify-center tw-text-center tw-bg-white tw-text-charcoal tw-border',
                        node.continued ? 'tw-border-dashed tw-border-charcoal-60' : 'tw-border-solid tw-border-blue',
                    )}
                    style={{
                        ...box(left + node.x, top + node.y, node.w, node.h),
                        fontSize: pt(node.size ?? ORG_CHART.NODE_FONT_PT),
                        lineHeight: 1.15,
                        paddingInline: ORG_CHART.TEXT_INSET,
                    }}
                >
                    {/* The name comes with its continued marker, at the size it was fitted to. */}
                    <span className="tw-break-words">{node.name}</span>
                </div>
            ))}
        </>
    );
};

export default OrgChartBlock;
